module.exports = __webpack_public_path__ + "static/media/digi_plink.bd34c76a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/digi_plink.wav
// module id = 112
// module chunks = 0